<oui-layout [logoUrl]="logoUrl">
  <oui-header [userMenu]="userMenu" [userName]="userName()" logoLink="/">
    <ng-container oui-header-actions>
      <div class="header-meta">
        @if (status(); as vm) {
          <oui-tag
            type="status"
            [status]="vm.rollbackInsteadOfCommit ? 'pending' : 'completed'"
          >
            {{ vm.transactionMode }}
          </oui-tag>
        }
      </div>
    </ng-container>
  </oui-header>

  @if (currentUser() && !applicationStatusUnavailable()) {
    <oui-navigation-panel [menus]="[navigationMenu]"></oui-navigation-panel>
  }

  <oui-content-layout>
    @if (applicationStatusUnavailable()) {
      <oui-error-page
        pageTitle="DoublonsBuster est actuellement injoignable."
        image="error"
      >
        <div class="application-status-error">
          <p>
            Impossible de joindre DoublonsBuster pour le moment. Avant de
            réessayer, vérifiez que vous remplissez bien les conditions
            suivantes :
          </p>

          <ul>
            <li>Être bien connecté au VPN.</li>
            <li>Ne pas être connecté avec un compte consultant sur le CAS.</li>
            <li>Avoir les droits d'accès à l'application.</li>
          </ul>
        </div>
      </oui-error-page>
    } @else {
      <router-outlet></router-outlet>
    }
  </oui-content-layout>
</oui-layout>
